module.exports = {
          srcSet: "/_next/static/images/logo-160-146c780319aaf0fbc1f783c51b7f345f.png"+" 160w",
          images:[ {path: "/_next/static/images/logo-160-146c780319aaf0fbc1f783c51b7f345f.png",width: 160,height: 212}],
          src: "/_next/static/images/logo-160-146c780319aaf0fbc1f783c51b7f345f.png",
          toString:function(){return "/_next/static/images/logo-160-146c780319aaf0fbc1f783c51b7f345f.png"},
          
          width: 160,
          height: 212
        }